import Grid from '@material-ui/core/Grid';
import styled, { css } from "styled-components";
import Button from '../../../components/Button';

interface BoxIconProps {
    color?: string;
}

export const ContentList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
`;

export const ContainerFields = styled(Grid)`
    background-color: white;
    width: 100%;
    border-radius: 10px 10px 10px 10px;
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    height: 100%;
`;

export const ContainerList = styled.div`
    margin: 10px;
    margin-top: 10px;
    margin-left: 5px;
    margin-right: 5px;
    position: relative;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 250px); /* Ajuste conforme necessário */
`;

export const TableHeader = styled.div`
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;
    border-bottom: 2px solid #f0f0f0;
`;

export const TableBody = styled.div`
    overflow-y: auto;
    flex: 1;
    
    /* Para esconder a scrollbar em navegadores WebKit (Chrome, Safari) */
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }

    .list-container-main {
        min-height: 300px;
    }
`;

export const BoxIcon = styled.div<BoxIconProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    background-color: #f23b5d;
    color: white;
    border-radius: 5px;
    font-size: 13px;
    margin-right: 10px;

    div {
        display: flex;
        font-size: 13px !important;
    }

    ${props => props.color && css`
        background-color: ${props.color};
    `}
`;

export const AutomaticData = styled.span`
    line-height: 1;
    margin: 0px 2px;
    padding: 3px 5px;
    white-space: nowrap;
    border-radius: 3px;
    font-size: 13px;
    border: 1px solid rgb(238, 238, 238);
    color: rgba(51, 51, 51, 0.9);
    background-color: rgb(248, 248, 248);
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 8px 10px;
  width: 400px;
  border: 1px solid #e9ecef;
  transition: all 0.2s;
  position: relative;

  svg {
    color: #adb5bd;
    font-size: 18px;
    margin-right: 8px;
  }

  &:focus-within {
    border-color: #9337ed;
    box-shadow: 0 0 0 3px rgba(147, 55, 237, 0.1);
    
    svg {
      color: #9337ed;
    }
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background-color: transparent;
  font-size: 14px;
  color: #495057;

  &::placeholder {
    color: #adb5bd;
  }
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #adb5bd;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    font-size: 16px;
    color: #adb5bd;
    margin-right: 0px !important;
  }
  
  &:hover {
    color: #6c757d;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const ExportButton = styled(Button)`
    padding: 4px 10px;
    font-size: 14px;    
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f8f9fa;
    border: 1px solid gray;
    color: #2e2e2e;

    div {
        margin-top: 0px !important;
        margin-right: 5px !important;

        svg {
            width: 17px;
        }
    }

    :hover {
        background: #f0f0f0;
        border: 1px solid #2e2e2e;
        color: #2e2e2e;
    }
`;

export const ActionButton = styled(Button)`
    padding: 4px 20px;
    font-size: 14px;
    margin-left: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #9e36ec;
    border-color: #9e36ec;
    color: white;
    box-shadow: 0 0 0 3px rgba(147, 55, 237, 0.1);

    div {
        margin-top: 0px !important;
        margin-right: 5px !important;

        svg {
            width: 17px;
        }
    }    

    :hover {
        background: #9337ed;
        border-color: #9337ed;
        color: white;
        opacity: 0.9;
    }
`;

export const UserCountText = styled.p`
  font-size: 12px;
  color: #6c757d;
  margin-top: 2px;
  margin-left: 2px;
  text-align: left;
`;

export const ContainerLoader = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(305px - 65px);
`;

export const Animation = styled.div`
    display: flex;
    top: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    svg {
        height: 30% !important;
        max-width: 150px;
    }
    
`;

export const DropDownMenuContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;        
    width: 45px !important;
    height: 35px !important;

    .col-hed-conf {
        border: none;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #4d4d4d;
        font-weight: 500;
        font-size: 13px;
        padding: 5px 10px;
        width: 45px !important;
        height: 35px !important;
        
        
        svg {
            font-size: 18px;
            margin-top: 1px;
        }

        :hover {
            background-color: #f4f4f4;        
            border-radius: 5px;
        }
    }

    .col-hed-con-conf {
        right: 45px;
        position: fixed;
        min-width: 250px;
    }
`;

export const UserTypeSelect = styled.select`
    border: 1px dashed #dfe7f0;
    padding: 2px 5px 2px 5px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    // Add transition and disabled style
    transition: all 0.2s ease;
    
    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        background-color: #f9f9f9;
    }
`;